<template>
    <div class="internal">

        <header-view
            :titulo="titulo"
            :breadcrumbs="true"
            :categories="categories"
            :category="Institucional">
        </header-view>

        <div class="container">

            <div class="row">

                <!-- Single Commerce -->
                <div class="single-commerce">
                    <div class="col-sm-offset-2 col-sm-8">

                        <h1>Real System</h1>

                        <p style="margin-top: 30px;"></p>
                        <p style="margin-top: 30px; margin-bottom:50px;">Os anúncios publicitários aqui são de responsabilidade exclusiva de seus respectivos anunciantes, bem como o conteúdo editorial dos anuncios. Declinamos toda e qualquer responsabilidade legal advinda dos anuncios acessadas através da Mundial Info, o qual tem por objetivo apenas a divulgação.</p>

                    </div>
                </div>
                <!-- End Single Commerce -->

            </div>
        </div>
        <!-- / End Empresas -->

        <footer-view></footer-view>
    </div>
</template>

<script>
import HeaderView from './layout/Header'
import FooterView from './layout/Footer'
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import HTTP_Api from "../services/api.service";

export default {
  name: 'Institucional',
  props: {
  },
  components: {
    HeaderView,
    FooterView,
    PulseLoader
  },
  data: function () {
    return {
      titulo: 'A empresa',
      categories: [],
      clients: Object,
      category: '',
      loading: true,
      status: false,
    }
  },
  methods: {
    getHome(pagenum) {
      this.loading = true;
      HTTP_Api.getHomeData(pagenum)
        .then(response => {
          this.status = response.data.status;
          this.clients = response.data.clients;
          this.categories = response.data.categories;
          this.meta = response.data.meta;
          this.loading = false;
          //console.log('this.clients',this.clients)
        })
        .catch(e => {
          this.errors.push(e);
        });
    },
  },
  created() {
    this.getHome();
  },
  computed: {
    user () {
      return {
        displayName: '',
        avatar: '',
        roles: ['', '']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Institucional.vue